module.exports = __webpack_public_path__ + "static/media/strongher1.c0c49cb3.jpg";